<template>
  <v-card tile flat>
    <v-select
        :value="periodValue"
        @change="setValue"
        :items="items"
        item-text="text"
        item-value="value"
        label="Játékrész"
        height="100%"
        tile
        flat
        single-line
        hide-details
        solo
        class="time-select theme-background theme-border"
        :disabled="!enabled"
        :append-icon="getIcon()"
    >
    </v-select>

    <v-row justify="center" class="dialog-container">
      <v-dialog v-model="periodChangeModal.show" persistent max-width="500">
        <v-card tile flat>
          <v-card-title class="headline">Periódus csere</v-card-title>
          <v-card-text>
            <p>Biztos szeretne a periódusok között <b>vissza</b> váltani?</p>
            <p>{{periodChangeModal.old.text}} <v-icon class="ml-2 mr-2 mb-1" style="font-size: 18px;">mdi-arrow-right</v-icon> {{periodChangeModal.new.text}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn depressed tile @click="keepPeriod">Nem</v-btn>
            <v-btn depressed tile @click="changePeriod" color="green">Igen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
import eventBus from '@/eventBus';
import CONSTANTS from '@/constants';
import { mapState } from 'vuex';

import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
  name: "Period",
  props: {
    items: Array,
    enabled: Boolean,
    currentPeriod: String,
  },
  data: () => ({
    periodValue: '1',
    periodChangeModal: {
      new: {
        text: '',
        value: null,
      },
      old: {
        text: '',
        value: null,
      },
      show: false,
    },
  }),
  computed: {
    ...mapState('game', ['timelineData']),
  },
  created() {
    let self = this;
    console.log("Period.vue created");

    this.$busOn(CONSTANTS.EVENTS.LASTTIMELOAD, function (data) {
      console.log("LASTTIMELOAD ->"+data);
      self.$emit('periodChanged', data.last.period);
    });

    // Figyeljük a globális váltást is
    this.$busOn(CONSTANTS.EVENTS.PERIOD.CHANGE, function (newValue) {
      console.log("PERIOD.CHANGE ->"+newValue);
      self.periodValue = String(newValue);
    });

    // JAVÍTÁS: Figyeljük az App.vue által küldött specifikus eseményt is!
    this.$busOn(CONSTANTS.EVENTS.PERIOD.CHANGED.SELECTEDPERIOD, function (newValue) {
      console.log("SELECTEDPERIOD ->"+newValue);
      if (String(newValue) !== String(self.periodValue)) {
        self.periodValue = String(newValue);
      }
    });
  },
  watch: {
    currentPeriod: {
      handler: function(value) {
        this.periodValue = value;
      },
      // JAVÍTÁS: immediate nélkül ez a figyelő csak a currentPeriod prop KÉSŐBBI
      // változásait észleli, a komponens létrehozásakor MÁR meglévő kezdőértéket
      // nem. Mivel a loadGameData() a helyes periódust MÁR beállítja, mielőtt a
      // Period.vue egyáltalán létrejönne (a reconnect/F5 utáni betöltés gyors),
      // a figyelő sosem látott "változást", és a legördülő a saját hardcode-olt
      // '1' alapértékén ragadt - ezt jelezte a felhasználó "mindig I. félidőt ír"
      // hibaként F5 után.
      immediate: true,
    },
    timelineData: {
      handler(newValue) {
        // DMR specifikus logika
        if (this.$route.meta.header === 'dmr' && newValue && newValue.length) {
          const changes = newValue.filter(x => x.action === 'periodchange');

          if (changes.length > 0) {
            changes.sort((a, b) => (b.clientTime || b.date || 0) - (a.clientTime || a.date || 0));

            const lastChange = changes[0];
            const newPeriod = lastChange.params ? lastChange.params.period : lastChange.period;

            // --- JAVÍTÁS: VÉDELEM A VISSZAÍRÁS (FLICKER) ELLEN ---
            if (this.currentPeriod && newPeriod) {
              const isStrand = this.$store.state.game.gamedata && this.$store.state.game.gamedata.rule === 'STRAND';
              const pCurrent = require('@/utils/periodOrder').getChronoOrder(this.currentPeriod, isStrand);
              const pNew = require('@/utils/periodOrder').getChronoOrder(newPeriod, isStrand);

              // Ha a jelenlegi (Socketből jött) periódus nagyobb/újabb, mint amit
              // az idővonal mutat (mert az még nem szinkronizált), akkor
              // NE engedjük visszaváltani a régit!
              if (pCurrent > pNew) {
                // console.log(`Period.vue [DMR]: Timeline lag detected. Ignored revert from ${pCurrent} to ${pNew}.`);
                return;
              }
            }
            // ----------------------------------------------------

            if (newPeriod && String(newPeriod) !== String(this.periodValue)) {
              this.periodValue = String(newPeriod);
              this.$emit('periodChanged', String(newPeriod));
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getIcon: function () {
      return this.enabled ? '$dropdown' : 'mdi-lock';
    },
    setValue: function(value) {
      let self = this;

      if (Number(value) < Number(self.currentPeriod)) {
        self.periodChangeModal.old = self.items.find((period) => period.value === self.currentPeriod);
        self.periodChangeModal.new = self.items.find((period) => period.value === value);
        self.periodChangeModal.show = true;
        eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, true);
        //override prev value
        self.$nextTick(() => {
          self.periodValue = '1';
          window.setTimeout(() => {
            self.periodValue = self.periodChangeModal.old.value;
          }, 1);
        });
      } else {
        self.setPeriod(value);
      }
    },
    setPeriod: function (value) {
      window.stopwatch.setClockToPeriod(value);
      this.$emit('periodChanged', value);

      // Csere oldal kezelése (csak lokális)
      if(this.$route.meta.header === 'substitute') {
        eventBus.$emit(CONSTANTS.EVENTS.PERIOD.CHANGED.SUBSTITUTE, value);
        return;
      }

      let event = {
        action: 'periodchange',
        approved: true,
        isDraft: false,
        checked: true,
        params: {
          period: value,
          approved: true,
          isDraft: false
        }
      };

      window.dbmanager.write(event);

      window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.SYNC, {type: 'periodchange', content: value});

      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.CLOSE);
      eventBus.$emit(CONSTANTS.EVENTS.PERIOD.CHANGED.CLOCK, value);
    },
    keepPeriod() {
      this.periodChangeModal.show = false;
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
    },
    changePeriod() {
      this.setPeriod(this.periodChangeModal.new.value);
      this.periodChangeModal.show = false;
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
      eventBus.$emit(CONSTANTS.EVENTS.PERIOD.CHANGED.SELECTEDPERIOD, this.periodChangeModal.new.value);
    },
  },
};
</script>

<style>
.time-select {
  border-radius: 0 !important;
  border-style: solid;
  border-left-width: 1px !important;
  border-right-width: 1px !important;
  border-top: 0;
  border-bottom: 0;
  width: 100%;
  max-width: 210px !important;
}

.time-select .v-input__control {
  min-height: 58px !important;
}

.time-select.theme--light .v-select__selection--comma, .time-select.theme--light .v-icon {
  color: #757575 !important;
}
.time-select.theme--light .v-input__slot {
  background-color: #ffffff !important;
}

.time-select.theme--dark .v-select__selection--comma, .time-select.theme--dark .v-icon {
  color: #9298af !important;
}
.time-select.theme--dark .v-input__slot {
  background-color: #262830 !important;
}

.v-input__slot {
  font-size: 14px;
  text-align: center;
}
</style>
